import { request } from 'umi';
import { APIConfig } from '@/config/common';

export async function GetDataList(params?: any) {
	return request(`${APIConfig.APIPrefix}/sys/department/list`, {
		method: 'POST',
		data: {
			...params
		},

	});

}

export async function GetTreeDataList(params?: any) {
	return request(`${APIConfig.APIPrefix}/sys/department/treelist`, {
		method: 'POST',
		data: {
			...params
		},

	});

}
export async function GetDepartmentUserTreelist(params?: any) {
	return request(`${APIConfig.APIPrefix}/sys/department/departmentusertreelist`, {
		method: 'POST',
		data: {
			...params
		},

	});

}
export async function SaveData(params?: any) {
	if (params?.bmbh) {
		return request(`${APIConfig.APIPrefix}/sys/department/update`, {
			method: 'POST',
			data: {
				...params
			},

		});

	}
	return request(`${APIConfig.APIPrefix}/sys/department/add`, {
		method: 'POST',
		data: {
			...params
		},

	});

}
// 生成区域
export async function generateAccount(params?: any) {
	if (params?.bmbh) {
		return request(`${APIConfig.APIPrefix}/sys/department/generateAccount`, {
			method: 'POST',
			data: {
				...params
			},

		});

	}

	return request(`${APIConfig.APIPrefix}/sys/department/add`, {
		method: 'POST',
		data: {
			...params
		},

	});

}

export async function DeleteData(params?: any) {
	return request(`${APIConfig.APIPrefix}/sys/department/delete`, {
		method: 'POST',
		data: {
			...params
		},
	});

}
export async function GetTreeDataListWowType(params?: any) {
	return request(`${APIConfig.APIPrefix}/sys/department/wowtype/treelist`, {
		method: 'POST',
		data: {
			...params
		},

	});

}
export async function GetDepartmentUserTreelistWowType(params?: any) {
	return request(`${APIConfig.APIPrefix}/sys/department/wowtype/departmentusertreelist`, {
		method: 'POST',
		data: {
			...params
		},

	});

}
export async function GetDepartmentDetail(params?: any) {
	return request(`${APIConfig.APIPrefix}/sys/department/detail`, {
		method: 'POST',
		data: {
			...params
		},

	});
}



export async function GetQymcDataList(params?: any) {
	return request(`${APIConfig.APIPrefix}/sys/department/getqymclist`, {
		method: 'POST',
		data: {
			...params
		},

	});

}
